import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./Pages/Index";
import TicketsPage from "./Pages/TicketsPage";
import Login from "./Pages/Login";
import ProtectedRoute from "./Pages/ProtectedRoute"; // اضافه شد
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route
          path="/ticketsPage"
          element={
            <ProtectedRoute>
              <TicketsPage />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
